import { memo } from 'react';

import TableIconSVG from '@/assets/field-type-table.svg?react';
import { Icon, IconProps } from '@/components/core';

const ITableIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={TableIconSVG} {...props} />;

export const TableIcon = memo(ITableIcon) as typeof ITableIcon;
